import React from 'react';
import KPISet from '../components/KPISet';
import List from './List';

const dataProviderName = 'audiences/audiencerpolead';

const Default = () => {
    const now = new Date();
    const startOfYear = new Date(`${now.getFullYear()}-01-01`);
    const defaultFilters = {
        items: []
    };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <List filters={defaultFilters} />
    </>

}

export default Default;


